import React, { CSSProperties, useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import * as DateFns from 'date-fns';

import Navbar from '../Navbar/NavBar';
import Loader from '../Shared/Loader';
import Table, { RowsType } from '../Shared/CustomTable';
import { useProcessingStatusDispatch, useProcessingStatusState, useTablePropertiesState } from '../../store/hooks';
import { Chunk, RowCell3DataType, RowData } from './types';
import { TEAMS_ALL } from 'config/constants';

type teamNamesAndIdsType = {
  teamName: string,
  teamId: string
}
const header = [
  { content: 'DATE', class: 't-ll', style: { width: 155 }, isOrderly: true },
  { content: 'DATASET', class: 't-ll', style: { width: 160 } },
  { content: 'DESC', class: 't-ll', style: { width: 260 } },
  { content: 'STATUS', class: 't-ll', style: { width: 180 } },
  { content: 'WARNINGS', class: 't-ll', style: { width: 120 } },
  { content: 'TRACKING', class: 't-ll', style: { width: 396 } }
];

const TEAMS_TEST = [
  {
    teamName: 'Bears Test Practice',
    teamId: '0811',
    teamAbbr: 'ZEBRA',
    teamNick: 'Zebra Team'
  },
  {
    teamName: 'Phily Test Practice',
    teamId: '3701',
    teamAbbr: 'ZEBRA',
    teamNick: 'Zebra Team'
  }

];

export default () => {
  
  const { data: newData = [] } = useProcessingStatusState();
  const { orderColumn = 0 } = useTablePropertiesState();
  const { loadDataProcessingStatus } = useProcessingStatusDispatch();
  const isMobile = window.matchMedia("only screen and (max-width: 900px)").matches;
  
  useEffect(() => {
    const localDate = new Date();
    const tzOffset = -localDate.getTimezoneOffset();
    if(!isMobile)loadDataProcessingStatus(tzOffset);
  }, []);

  const sortArrayIds = ( a:teamNamesAndIdsType, b:teamNamesAndIdsType ) => {
    if ( a.teamName < b.teamName ){
      return -1;
    }
    if ( a.teamName > b.teamName ){
      return 1;
    }
    return 0;
  };
  const processedPractices: Array<JSX.Element> = [];
  const teamsHeaders: { data: Array<JSX.Element>, rows: RowsType<RowCell3DataType, RowData, string> }[] = [];
  const order = orderColumn < 0 ? 1 : -1;
  newData.sort((a: Chunk, b: Chunk) => {
    const keyA = Object.keys(a)[0];
    const keyB = Object.keys(b)[0];
    return order * keyA.localeCompare(keyB);
  });
  let rows: RowsType<RowCell3DataType, RowData, string> = [];
  newData.forEach((chunk: Chunk, index) => {
    const key = Object.keys(chunk)[0];
    const teamId = Object.keys(chunk[key]).map(team =>{
      return team;
    });

    const teamNamesAndIds: teamNamesAndIdsType[] =[];

    teamId.forEach(data =>{
      let names;
      if(data.includes('19410')){
        names = 'Ohio State Buckeyes';
      }else if(data === '0811' || data === '3701'){
        names = TEAMS_TEST.find(x=>x.teamId === data)?.teamName;
      } else{
        names = TEAMS_ALL.find(x=> x.teamId === data)?.teamName;
      }
      if(names){
        teamNamesAndIds.push({teamName: names, teamId: data});
      }else{
        teamNamesAndIds.push({teamName: 'Undefined', teamId: data});
      }
    });
    teamNamesAndIds.sort(sortArrayIds);

    const teamAbbr = teamNamesAndIds.map(data =>{
       if(data.teamName === 'Bears Test Practice' || data.teamName === 'Phily Test Practice'){
        return TEAMS_TEST.find(x=>x.teamName === data.teamName)?.teamAbbr;
      }
        return TEAMS_ALL.find(x=> x.teamName === data.teamName)?.teamAbbr;
      });

    const loopTeams = teamId.length;
    for(let i=0; i < loopTeams ; i++){
    rows = chunk[key][teamNamesAndIds[i].teamId].map((rowData: RowData) => {
      const rowColorStyle: CSSProperties = rowData.live === 'true' ?
        { backgroundColor: '#b4dbb5' } :
        rowData.status === 'INPROGRESS' ? { backgroundColor: '#d8a3f0' } : {};
     return {
        columns: [
          { content: key, class: 't-ll', style: {...rowColorStyle, fontWeight: 'bold'} },
          { content: rowData.datasetId, class: 't-ll', style: rowColorStyle }, // '(t:POST, att:4)'
          {
            content: {
              procStartTime: DateFns.isValid(new Date(+rowData.procStartTime)) ?
                DateFns.format(new Date(+rowData.procStartTime), 'hh:mm:ss') :
                '-',
              procEndTime: DateFns.isValid(new Date(+rowData.procEndTime)) && +rowData.procEndTime ?
                DateFns.format(new Date(+rowData.procEndTime), 'hh:mm:ss') :
                '-',
            },
            print: (content: RowCell3DataType) => (
              <>
                <label>{rowData.description}</label><br />
                <label><b>Process start:</b> {content.procStartTime}</label><br />
                <label><b>Process end:</b> {content.procEndTime}</label><br />
              </>
            ),
            class: 't-ll', style: rowColorStyle
          },
          {
            content: rowData.live === 'true' ? 'LIVE' : rowData.status === 'INPROGRESS' ? 'PROCESSING' : rowData.status,
            class: 't-ll',
            style: rowColorStyle
          },
          { content: rowData.warnings, class: 't-ll', style: rowColorStyle },
          {
            print: () => (
              <>
                <label><b>Process tracks count:</b> {rowData.procTrackCnt}</label><br />
                <label><b>Total Tracks:</b> {rowData.totTrackCnt}</label><br />
                <label><b>Total BallFlights:</b> {rowData.totalBallFlights}</label><br />
                <label><b>Entities:</b> {rowData.totalEntities} <b>Players:</b> {rowData.totalPlayers} <b>Balls:</b> {rowData.totalBalls}</label><br />
              </>
            ),
            style: rowColorStyle
          } // '1DP=4,559,581, Rate=0.095%, Filter=0.000%'
        ],
        id: rowData.datasetId,
        timeId: rowData.procStartTime.toString()
        
    };
    });
  
     teamsHeaders.push({
      data:[(
        <>
        {i >0?
        null
        :
        <div className="caption-processing-date" id={'date-key'+index}>
          <label>{'DATE '+ key}</label>
        </div>
      }
         
      <div className="caption-processing">
       <label><img src={`/assets/images/logos/${teamAbbr[i]}.svg`} alt="" width="30px"/>{ Array(12).fill('\xa0').join('')+ teamNamesAndIds[i].teamName}</label>
      </div>    
                  </> 
      )],
      rows: rows.sort((a,b)=> +a.id === +b.id? a.timeId && b.timeId? +a.timeId - +b.timeId : +a.id - +b.id : +a.id - +b.id)
    });
  }
});

    processedPractices.push(
    <>  
    <div>
    {teamsHeaders.map(team =>{
        return (
          <>
            <div>
              {team.data}
            </div>
            <Table
              classTable="processing-status-body"
              headers={header}
              rows={team.rows}
            />
          </>
          );
      })}
    </div>
    </>
  );
  

  return (
    <>
      <Navbar />
      <Container className="container-00 status-00">
      <h4 className="h-t">Processing Status</h4>
        <Row>
          <Col lg={12} xs={12}>
            <div className="monitor fixed-00" style={{overflowX:'hidden'}}>
              <Loader>
                <>
                <Table
                    classTable="processing-status-headers"
                    headers={header}
                    rows={[]}
                    isCombinedTable={true}
                  />
                  <div className='caption-processing-body'>
                  {processedPractices}
                  </div>
                </>
              </Loader>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};
